import useUserPresence from '../../hooks/useUserPresence';

/** Mounted once for all authenticated routes; sends presence heartbeats. */
export default function PresenceHeartbeat() {
  useUserPresence();
  return null;
}
